import {
    Link,
    LinkProps
} from "@fluentui/react-components";


interface LinkCustomProps {
  rcName?: string;
  theme?: string;
}

const LinkCustom = (props: LinkCustomProps & LinkProps) => {
  return (
    <Link {...props} />
  );
};

export default LinkCustom;
